import React from 'react';
import logo from '../../../assets/images/Header.png';
import profile from '../../../assets/icons/profile.png';
import { NavLink, useLocation } from 'react-router-dom';
import { Modal, message, Button, Dropdown, Menu } from 'antd';
import LocalStorage from '../../../utilities/localStorage.js';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../../../features/login/redux/slice.js';
import { useMsal } from '@azure/msal-react';
import { history } from '../../../app/history.js';
import barChart from '@assets/icons/dashboard_tab.svg';
import barChartIcon from '@assets/icons/dashboard_tab_active.svg';
import tool_adherence_tab from '@assets/icons/tool_adherence_tab.svg';
import tool_adherence_tab_active from '@assets/icons/tool_adherence_tab_active.svg';
import viewerBgImg from '@assets/images/dsahboard_bg.png';
import trainingVideoIcon from '@assets/icons/traininfVideo_white.svg';
import trainingVideoActiveIcon from '@assets/icons/trainingVideo_active.svg';
import userManualIcon from '@assets/icons/userManual_white.svg';
import userManualActiveIcon from '@assets/icons/userManual_active.svg';

const Navbar = () => {
  const location = useLocation();
  const user_details = LocalStorage.getItem('bbs_user');
  const [userDetails, setUserDetails] = useState(null);
  const navigate = useNavigate();
  //console.log(user_details?.user?.Role?.role)

  const { instance } = useMsal();
  const dispatch = useDispatch();
  const user = LocalStorage.getItem('bbs_user');
  const [selectedMenuKeys] = useState(
    history.location.pathname.replace('/', ''),
  );

  const renderText = () => {
    // if (user_details?.user?.Role?.role === 'REQUESTER') {
    //   // Logic for REQUESTER role
    //   switch (location.pathname) {
    //     case '/dashboard':
    //     case '/request-approval':
    //     case '/quarterly-input':
    //       return `Hello Again, ${user_details?.user?.givenName}!`;
    //     case '/bbs-optimization':
    //       return 'BBS Calculations';
    //     default:
    //       return '';
    //   }
    // } else if (user_details?.user?.Role?.role === 'MANAGER') {
    //   // Logic for MANAGER role
    //   if (
    //     location.pathname === '/quarterly-input' ||
    //     location.pathname.includes('/approve-reject')
    //   ) {
    //     return `Hello again,  ${user_details?.user?.givenName}!`;
    //   }
    //   switch (location.pathname) {
    //     case '/dashboard':
    //       return `Welcome,  ${user_details?.user?.givenName}!`;
    //     case '/leadership-dashboard':
    //       return `Welcome,  ${user_details?.user?.givenName}!`;
    //     default:
    //       return '';
    //   }
    // }
    return `Welcome,  ${user_details?.user?.givenName}!`; // Default case if role is neither REQUESTER nor MANAGER
  };

  useEffect(() => {
    const user_details = JSON.parse(localStorage.getItem('bbs_user'));
    setUserDetails(user_details);
  }, []);

  // const handleLogout = () => {
  //   // Step 1: Clear the localStorage
  //   localStorage.clear();

  //   // Step 2: Clear session-related data (if stored in cookies or memory)
  //   document.cookie = ''; // Clear cookies
  //   sessionStorage.clear(); // Clear session storage

  //   // If you use authentication tokens, clear them explicitly
  //   // Example (if using a state management library like Redux):
  //   // dispatch(logoutAction());

  //   // Step 3: Show success message after logout
  //   message.success('Logged out successfully');

  //   // Step 4: Redirect to the login page
  //   navigate('/login');
  // };
  const handleLogout = () => {
    console.log('Logging Triggered');
    instance?.logoutRedirect({
      account: LocalStorage.homeAccountId,
      postLogoutRedirectUri: '/',
      mainWindowRedirectUri: '/',
      onRedirectNavigate: (url) => {
        console.log('url', url);
        dispatch(logout());
        return true;
      },
    });
  };
  const menu = (
    <Menu>
      <Menu.Item disabled>
        <div>
          <strong>Role:</strong>{' '}
          <span style={{ color: '#333' }}>
            {userDetails?.user?.Role?.role || 'N/A'}
          </span>
        </div>
      </Menu.Item>
      <Menu.Item disabled>
        <div>
          <strong>Name:</strong>{' '}
          <span style={{ color: '#333' }}>
            {userDetails?.user?.givenName || 'N/A'}
          </span>
        </div>
      </Menu.Item>
      <Menu.Item disabled>
        <div>
          <strong>Email:</strong>{' '}
          <span style={{ color: '#333' }}>
            {userDetails?.user?.email || 'N/A'}
          </span>
        </div>
      </Menu.Item>
      <Menu.Item>
        <Button className="next-button" type="primary" onClick={handleLogout}>
          Logout
        </Button>
      </Menu.Item>
    </Menu>
  );

  return (
    <div
      className={`header h-[73px] ps-0 pe-3 lg:px-3 2xl:px-6 flex justify-between top-0  ${user_details?.user?.Role?.role === 'VIEWER' ? 'sticky top-0' : 'relative border-b-0'}  z-30 items-center border-gray-200 bg-[#1C4E9D]`}
    >
      {user_details?.user?.Role?.role === 'VIEWER' ? (
        <div className="flex items-center gap-3 header-left sm:gap-4">
          <img
            src={logo}
            className="w-[150px] sm:w-[180px] md:w-[200px] cursor-pointer"
            alt="Logo"
          />
        </div>
      ) : (
        <div className="flex items-center gap-3 header-left sm:gap-4">
          <div className="relative before:content-[''] md:ml-[-1px] before:absolute before:right-0 before:top-1/2 before:-translate-y-1/2 before:w-[1px] before:h-[40px] sm:before:h-[84px] before:bg-[rgba(224,231,255,0.2)] before:mr-1">
            <img
              src={logo}
              className="w-[150px] sm:w-[180px] md:w-[200px] cursor-pointer"
              alt="Logo"
            />
          </div>
          <div className="ml-2 text-sm text-white nav-text sm:text-base md:text-lg lg:text-xl sm:ml-4">
            <p>{renderText()}</p>
          </div>
        </div>
      )}

      {/* navigation links */}
      {user_details?.user?.Role?.role === 'VIEWER' ? (
        <div className="flex gap-4 mr-36">
          <NavLink
            className={({ isActive }) =>
              isActive
                ? 'flex items-center font-medium no-underline gap-1 p-[10px_10px] rounded-lg bg-[#F6FAFF] h-[36px] shadow-[inset_0px_0px_4px_0px_rgba(0,0,0,0.15)] border-r-[3px] border-[#1C4E9D] text-[#1C4E9D]'
                : 'opacity-50 flex items-center no-underline text-[#FFFFFF] gap-1 p-[5px_10px] rounded-lg'
            }
            to="/viewer/dashboard"
          >
            {({ isActive }) => (
              <>
                <img
                  src={isActive ? barChartIcon : barChart}
                  alt="Dashboard Icon"
                  className="w-[20px] h-[20px]"
                />
                <p className="font-['SF-Pro-Text-Regular, sans-serif'] text-[12.5px]  m-0">
                  Dashboard
                </p>
              </>
            )}
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive
                ? 'flex items-center font-medium no-underline  gap-1 p-[10px_10px] rounded-lg bg-[#F6FAFF] h-[36px] shadow-[inset_0px_0px_4px_0px_rgba(0,0,0,0.15)] border-r-[3px] border-[#1C4E9D] text-[#1C4E9D]'
                : 'opacity-50 flex items-center no-underline text-[#FFFFFF] gap-1 p-[5px_10px] rounded-lg'
            }
            to="/viewer/tool-adherence"
          >
            {({ isActive }) => (
              <>
                <img
                  src={
                    isActive ? tool_adherence_tab_active : tool_adherence_tab
                  }
                  alt="Dashboard Icon"
                  className="w-[20px] h-[20px]"
                />
                <p className="font-['SF-Pro-Text-Regular, sans-serif'] text-[12.5px]  m-0">
                  Tool Adherence
                </p>
              </>
            )}
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive
                ? 'flex items-center font-medium no-underline  gap-1.5 p-[10px_10px] rounded-lg bg-[#F6FAFF] h-[36px] shadow-[inset_0px_0px_4px_0px_rgba(0,0,0,0.15)] border-r-[3px] border-[#1C4E9D] text-[#1C4E9D]'
                : 'opacity-50 flex items-center no-underline text-[#FFFFFF] gap-1 p-[5px_10px] rounded-lg'
            }
            to="/training-manual"
          >
            {({ isActive }) => (
              <>
                <img
                  src={isActive ? userManualActiveIcon : userManualIcon}
                  alt="Dashboard Icon"
                  className="h-5 mt-0.5"
                />
                <p className="font-['SF-Pro-Text-Regular, sans-serif'] text-[12.5px]  m-0">
                  User Manual
                </p>
              </>
            )}
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive
                ? 'flex items-center font-medium no-underline  gap-1.5 p-[10px_10px] rounded-lg bg-[#F6FAFF] h-[36px] shadow-[inset_0px_0px_4px_0px_rgba(0,0,0,0.15)] border-r-[3px] border-[#1C4E9D] text-[#1C4E9D]'
                : 'opacity-50 flex items-center no-underline text-[#FFFFFF] gap-1 p-[5px_10px] rounded-lg'
            }
            to="/training-video"
          >
            {({ isActive }) => (
              <>
                <img
                  src={isActive ? trainingVideoActiveIcon : trainingVideoIcon}
                  alt="Dashboard Icon"
                  className="h-5 mt-0.5"
                />
                <p className="font-['SF-Pro-Text-Regular, sans-serif'] text-[12.5px]  m-0">
                  Training Video
                </p>
              </>
            )}
          </NavLink>
        </div>
      ) : null}

      {/* Right Section */}
      <div className="flex items-center">
        <Dropdown overlay={menu} trigger={['click']}>
          <img
            src={profile}
            className="object-cover w-8 h-8 rounded-full cursor-pointer sm:w-10 sm:h-10 md:rounded-none"
            alt="Profile"
          />
        </Dropdown>
      </div>
    </div>
  );
};

export default Navbar;
